import { FC } from "react";

/** Light grey world map placeholder with Pakistan highlighted */
const WorldMapPlaceholder: FC = () => {
  return (
    <div className="world-map-placeholder">
      <svg
        viewBox="0 0 400 220"
        className="world-map-placeholder__svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <filter id="softShadow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="2"/>
            <feOffset dx="0" dy="1" result="offsetblur"/>
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.2"/>
            </feComponentTransfer>
            <feMerge>
              <feMergeNode/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>
        
        {/* Background */}
        <rect width="400" height="220" fill="#fafbfd"/>
        
        {/* Continents - very light gray */}
        {/* Europe */}
        <path
          fill="#e8ecf3"
          stroke="#dde3ec"
          strokeWidth="0.5"
          d="M140 45 L165 42 L185 48 L195 62 L185 75 L160 78 L145 68 Z"
        />
        
        {/* Asia */}
        <path
          fill="#e8ecf3"
          stroke="#dde3ec"
          strokeWidth="0.5"
          d="M200 35 L280 30 L320 45 L335 65 L325 85 L290 95 L250 90 L210 75 L195 55 Z"
        />
        
        {/* Africa */}
        <path
          fill="#e8ecf3"
          stroke="#dde3ec"
          strokeWidth="0.5"
          d="M145 85 L180 82 L200 95 L205 125 L195 155 L170 165 L145 155 L135 125 Z"
        />
        
        {/* North America */}
        <path
          fill="#e8ecf3"
          stroke="#dde3ec"
          strokeWidth="0.5"
          d="M45 40 L85 35 L110 50 L115 75 L105 95 L75 98 L50 85 L40 60 Z"
        />
        
        {/* South America */}
        <path
          fill="#e8ecf3"
          stroke="#dde3ec"
          strokeWidth="0.5"
          d="M70 105 L95 100 L105 115 L108 145 L100 170 L85 180 L70 175 L65 145 Z"
        />
        
        {/* Australia */}
        <path
          fill="#e8ecf3"
          stroke="#dde3ec"
          strokeWidth="0.5"
          d="M310 130 L340 128 L355 140 L350 160 L330 165 L310 158 Z"
        />
        
        {/* Pakistan highlighted - larger and more prominent like in screenshot 1 */}
        <path
          fill="#4a8fd9"
          stroke="#3679c7"
          strokeWidth="1"
          filter="url(#softShadow)"
          d="M235 62 L242 58 L250 60 L254 68 L252 78 L245 82 L237 80 L233 72 Z"
        />
        
        {/* Highlight dot for emphasis (like in screenshot 1) */}
        <circle
          cx="243"
          cy="70"
          r="5"
          fill="#3679c7"
          opacity="0.9"
        />
      </svg>
    </div>
  );
};

export default WorldMapPlaceholder;